import { render } from "./EmailPreferences.vue?vue&type=template&id=4c601f2c&scoped=true"
import script from "./EmailPreferences.vue?vue&type=script&lang=js"
export * from "./EmailPreferences.vue?vue&type=script&lang=js"

import "./EmailPreferences.vue?vue&type=style&index=0&id=4c601f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c601f2c"]])

export default __exports__